import React from 'react';
import { InfoMessage, ErrorMessage } from './MessageTypes';

const CustomizableByAssociatesOnlyMessage = (phoneNumber) => {
  const message = (
    <span>This product&apos;s specific options are customizable by associates only.
      To edit, call&nbsp;
      <a href={`tel:${phoneNumber}`}>
        {phoneNumber}
      </a>
    </span>
  );
  return InfoMessage(message);
};

const EditSwapDeleteError = () => {
  const message = 'Edit, swap, or delete this product to correct any customizations no longer available before purchasing.';
  return ErrorMessage(message);
};

const DiscontinuedProductError = () => {
  const message = 'This product has been discontinued. Swap or delete this product before purchasing.';
  return ErrorMessage(message);
};

const CopyStylesProductError = () => {
  const message = 'Unable to copy style. Source style is not compatible with this window\'s dimensions.';
  return InfoMessage(message);
};

const ItemMessage = ({
  phoneNumber,
  isCustomerViewingCustomProduct,
  isMandi,
  invalid,
  isDiscontinued,
  isCopyStylesValid,
  isCopyStylesErrorMsg,
}) => {
  if (!isMandi && invalid) {
    return EditSwapDeleteError();
  }
  if (isDiscontinued) {
    return DiscontinuedProductError();
  }
  if (isCustomerViewingCustomProduct) {
    return CustomizableByAssociatesOnlyMessage(phoneNumber);
  }
  if (!isCopyStylesValid && isCopyStylesErrorMsg) {
    return CopyStylesProductError();
  }
  return null;
};

export default ItemMessage;
